import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconInfoRoundedFilled = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M16 2.667c7.364 0 13.333 5.969 13.333 13.333S23.363 29.333 16 29.333 2.667 23.363 2.667 16 8.637 2.667 16 2.667m-1.096 11a1 1 0 0 0 0 2h.333v4.666h-.667a1 1 0 0 0 0 2h3.334a1 1 0 0 0 0-2h-.667v-5.666a1 1 0 0 0-1-1zm1-4.663a1.496 1.496 0 1 0 0 2.992 1.496 1.496 0 0 0 0-2.992" /></svg>;
export default SvgIconInfoRoundedFilled;